import http from './http';
import config from '~/config';

const endpoint = `${config.urls.base}`;

export const getFirmData = async (backDate) => {
    const uri = `${endpoint}/me/orders`;
  
    return http.get2(uri, { backDate });
};

export const getMyFirmData = async (backDate) => {
    const uri = `${endpoint}/me/firm/orders`;
    
    return http.get2(uri, { backDate });
};

export default {
    getFirmData,
    getMyFirmData
};